import { getUser } from '../utilties/userUtilities'

/**
 * @obsolete
 * Register new patient
 *
 * @param {*} email
 * @param {*} username 
 * @param {*} password 
 */
export const signUp = (email, username, password) => {
	fetch('/api/registration', {
		method: 'post',

		body: JSON.stringify({ userName: username, email: email, password: password }),
		headers: { 'content-type': 'application/json' }
	})
		.then(function(response) {
			return response.json()
		})
		.then(function(data) {})
}

/**
 * Verifies MFA phone code.
 *
 * @param {string} code - the code
 * @param {string} mfaSign - The MFA sign from HTTP header
 * @returns {*} response indicating if the verification was successful
 */
export const completePhoneVerification = (code, mfaSign) => {
    return fetch(`/api/authorization/verifyPhone/code/${code}`, {
            method: 'post',
            headers: mfaSign ? { 'mfaSign': mfaSign } : {}
        })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (response) {
            return response
        })
}

/**
 * Register new patient either with verification token or using self-registration
 *
 * @param {string} email - patient's email
 * @param {string} password - patient's password
 * @param {boolean} rememberMe - flag indicating if patient wants to stay signed in
 * @param {string} language - patient's language
 * @param {string} token - verification token
 * @param {string} originalEmail - original email that was set on case creation (if any)
 * @returns {*} response indicating if the registration was successful
 */
export const registerUser = (email, password, rememberMe, language, token, originalEmail) => {
	return fetch(`/api/registration`, {
		method: 'post',
		body: JSON.stringify({
			email: email,
			password: password,
			rememberMe: rememberMe,
			language: language,
			verificationToken: token, 
			originalEmail: originalEmail
		}),
		headers: { 'content-type': 'application/json' }
	})
	.then(function (response) {
		if (response.status === 200) {
			return response.json()
		}
	})
	.then(function (response) {
		return response
	})
}

/**
 * Send verification code to patient's email to confirm it
 *
 * @param {string} email - patient's email
 * @param {string} language - patient's language
 * @returns {*} response indicating if the code was sent successfully
 */
export const sendVerificationCode = (email, language) => {
	return fetch(`/api/registration`, {
		method: 'post',
		body: JSON.stringify({ email: email, language: language }),
		headers: { 'content-type': 'application/json' }
	})
	.then(function (response) {
		if (response.status === 200) {
			return response.json()
		}
	})
	.then(function (response) {
		return response
	})
}

/**
 * Resend email with verification code to patient
 *
 * @param {string} email - patient's email
 * @returns {*} response indicating if the code was sent successfully
 */
export const resendVerificationCode = (email) => {
	return fetch(`/api/registration/resendEmailVerification`, {
		method: 'post',
		body: JSON.stringify({ email: email }),
		headers: { 'content-type': 'application/json' }
	})
	.then(function (response) {
		if (response.status === 200) {
			return response.json()
		}
	})
	.then(function (response) {
		return response
	})
}

/**
 * Submit the verification code that was sent to patient's email
 *
 * @param {string} email - patient's email 
 * @param {string} code - the verification code
 * @returns {*} response indicating if code confirmation was successful
 */
export const confirmCode = (email, code) => {
	return fetch(`/api/registration/confirm`, {
		method: 'post',
		body: JSON.stringify({ email: email, code: code }),
		headers: { 'content-type': 'application/json' }
	})
	.then(function (response) {
		if (response.status === 200) {
			return response.json()
		}
	})
	.then(function (response) {
		return response
	})
}

/**
 * Set patient's password
 *
 * @param {string} verificationCode - the verification code
 * @param {string} email - patient's email 
 * @param {string} password - patient's password
 * @param {boolean} rememberMe - flag indicating if patient wants to stay signed in
 * @param {string} language - patient's language 
 * @returns {*} response indicating if setting the password was successful
 */
export const setupPassword = (verificationCode, email, password, rememberMe, language) => {
	return fetch(`/api/registration/setupPassword`, {
		method: 'post',
		body: JSON.stringify({
			code: verificationCode,
			email: email,
			password: password,
			rememberMe: rememberMe,
			language: language
		}),
		headers: { 'content-type': 'application/json' }
	})
	.then(function (response) {
		if (response.status === 200) {
			return response.json()
		}
	})
	.then(function (response) {
		return response
	})
}

/**
 * Initiate patient self-enrollment
 *
 * @param {string} email - patient's email
 * @param {string} search - encrypted part of the self-registration link that contains circle information
 * @param {string} language - patient's language
 * @returns {*} response indicating if self-registration was initiated successfully
 */
export const selfRegisterUser = (email, search, language) => {
	return fetch(`/api/registrationPortal`, {
		method: 'post',
		body: JSON.stringify({ email: email, search: search, language: language }),
		headers: {
			'content-type': 'application/json',
			'time-zone-offset': `${-(new Date().getTimezoneOffset() / 60)}`
		}
	})
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(obj) {
			return obj
		})
}

/**
 * @obsolete use 'confirmCode' instead
 * Confirm patient's email with verification code
 *
 * @param {*} email 
 * @param {*} code 
 * @returns {*} 
 */
export const confirmUser = (email, code) => {
	return fetch(`/api/registration/confirm`, {
		method: 'post',
		headers: { 
			'content-type': 'application/json',
			'time-zone-offset': `${-(new Date().getTimezoneOffset() / 60)}`
		},
		body: JSON.stringify({ code: code, email: email })
	}).then(function(response) {
		return response.json()
	})
}

/**
 * Authorize patient
 *
 * @param {string} email - patient's email 
 * @param {string} password - patient's password
 * @param {boolean} rememberMe - flag indicating if patient wants to stay signed in
 * @param {string} language - patient's language
 * @returns {*} response indicating if the authorization was successful
 */
export const signIn = (email, password, rememberMe, language) => {
	return fetch(`/api/authorization`, {
		method: 'post',
		headers: { 
			'content-type': 'application/json',
			'time-zone-offset': `${-(new Date().getTimezoneOffset() / 60)}`
		 },
		body: JSON.stringify({ email: email?.trim(), password: password?.trim(), rememberMe: rememberMe, language: language })
	})
		.then(function(response) {
			return response.json()
		})
		.then(function(data) {
			return data
		})
}

/**
 * Log the patient out
 *
 * @returns {*} response indicating if the log out was successful
 */
export const signOut = () => {
	return fetch(`/api/authorization/signout`, {
		method: 'post',
		headers: { 'content-type': 'application/json' }
	}).then(function(response) {
		return response
	})
}

/**
 * Requests the email to initiate the password change
 *
 * @param {string} email - patient's email
 * @returns {*} response indicating if the forgot password email was sent successfully
 */
export const requestForgotPasswordEmail = (email) => {
	return fetch(`/api/authorization/requestpasswordchange`, {
		method: 'post',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({ email: email?.trim() })
	}).then(function(response) {
		return response
	})
}

/**
 * Resends the confirmation code for password change or user registration
 *
 * @param {string} email - patient's email
 * @returns {*} response indicating if the code was sent successfully
 */
export const resendConfirmationCode = (email) => {
	return fetch(`/api/authorization/resendConfirmationCode/${email}`, {
		method: 'post',
		headers: { 'content-type': 'application/json' }
	}).then(function(response) {
		return response
	})
}

/**
 * Confirms the password change after resetting it with 'forgot password'
 *
 * @param {string} email - patient's email
 * @param {string} code - verification code
 * @param {string} password - new patient's password
 * @returns {*} response indicating if the password was changed successfully
 */
export const confirmForgotPassword = (email, code, password) => {
	return fetch(`/api/authorization/confirmpasswordchange`, {
		method: 'post',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({ email: email, code: code, password: password })
	}).then(function(response) {
		return response.json()
	})
	.then(function(data) {
		return data
	})
}

/**
 * Refresh access token
 *
 * @returns {*} response indicating if the access token was updated successfully
 */
export const refreshToken = () => {
	var user = getUser()
	if (user) {
		return fetch(`/api/authorization/refresh/${user.id}`, { method: 'GET' })
	}
	else {
		return Promise.resolve()
	}
}

/**
 * Change patient's password
 *
 * @param {string} email - patient's email
 * @param {string} oldPassword - current password
 * @param {string} newPassword - new password
 * @returns {*} response indicating if the password was updated successfully
 */
export const changePassword = (email, oldPassword, newPassword) => {
	return fetch(`/api/authorization/changepassword`, {
		method: 'post',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({ email: email, newPassword: newPassword, oldPassword: oldPassword?.trim() })
	})
		.then(function(response) {
			return response.json()
		})
		.then(function(data) {
			return data
		})
}

/**
 * Process clinician authenticating on patient portal using his access token
 *
 * @param {string} data - encrypted object containing clinician access token and patient id
 * @returns {*} response indicating if the authorization was successful
 */
export const externalAuth = (data) => {
	return fetch(`/api/authorization/externalauth`, {
		method: 'post',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({ data: data })
	})
		.then(function(response) {
			return response.json()
		})
		.then(function(data) {
			return data
		})
}

/**
 * Auto sign in user when they are following a secure link
 *
 * @param {string} data - encrypted object containing information necessary for authorization
 * @param {string} token - verification token
 * @returns {*} response indicating if the authorization was successful
 */
export const autoSignIn = (data, token) => {
	return fetch(`/api/authorization/autosignin`, {
		method: 'post',
		headers: { 
			'content-type': 'application/json',
			'time-zone-offset': `${-(new Date().getTimezoneOffset() / 60)}`
		},
		body: JSON.stringify({
			data: data,
			token: token
		})
	}).then(function(response) {
		return response.json()
	})
	.then(function(data) {
		return data
	})
}

/**
 * Check patient status by email
 *
 * @param {string} email 
 * @returns {*} response indicating patient's status:
 * Registered = 0,
 * CaseCreated = 1,
 * NotFound = 2,
 * ChangePassword = 6
 */
export const checkEmail = (email) => {
	return fetch(`/api/authorization/checkEmail/${email?.trim()}`, {
		method: 'get'
	}).then(function(response) {
		if (response.status == 200) {
			return response.json()
		}
	})
	.then(function(data) {
		return data
	})	
}

/**
 * Get patient's registration status
 *
 * @param {string} email - patient's email
 * @param {string} token - token from self-registration link (can be empty)
 * @returns {*} response indicating patient's registration status:
 * UserNotFound = 0,
 * RegistrationNotStarted = 1,
 * ConfirmationCodeSent = 2,
 * ConfirmationCodeAccepted = 3,
 * PasswordSetUp = 4,
 * Registered = 5,
 * ChangePassword = 6
 */
export const getRegistrationStatus = (email, token) => {
	return fetch(`/api/registration/registrationStatus/${email}?token=${!!token ? token : ''}`, {
		method: 'get'
	}).then(function(response) {
		if (response.status == 200) {
			return response.json()
		}
	})
	.then(function(data) {
		return data
	})	
}

/**
 * Check if user with certain ID is the same as currently authorized user
 *
 * @param {number} userId - user ID to check
 * @returns {*} response indicating if it is the same user
 */
export const getIsAuthorizedUser = (userId) => {
	return fetch(`/api/authorization/isAuthorizedUser/${userId}`, {
		method: 'get'
	}).then(function(response) {
		return response.json()
	})
	.then(function(data) {
		return data
	})	
}

